import BreadCrumbHeader from "../../../../components/Header/BreadCrumbHeader.jsx";
import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Box,
  Typography,
  Button,
  FormControl,
  Container,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import GlobalToast from "../../../../components/Toasts/GlobalToast.jsx";

import step1 from "../../../../assets/step1.jpg";
import importimg from "../../../../assets/import.svg";
import exportimg from "../../../../assets/export.svg";
import uploadimg from "../../../../assets/radar.svg";
import headtag from "../../../../assets/headertag.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StepConnector from "@mui/material/StepConnector";

const useStyles = makeStyles({
  tableRow: {
    border: "1px solid rgba(224, 224, 224, 1)",
  },
});

const MediaOffline = [
  {
    key: 1,
    value: "Offline Media Output File - Newspaper/Magazines",
    name: "News Papers / Magazines",
  },
  {
    key: 2,
    value:
      "Offline Media Output File - Hoardings, Sky Walk, Wall Branding, Gantry Gate",
    name: "Gantry Gate",
  },
  {
    key: 3,
    value:
      "Offline Media Output File - Hoardings, Sky Walk, Wall Branding, Gantry Gate",
    name: "Hoardings",
  },
  {
    key: 4,
    value:
      "Offline Media Output File - Hoardings, Sky Walk, Wall Branding, Gantry Gate",
    name: "Skywalk",
  },
  {
    key: 5,
    value:
      "Offline Media Output File - Hoardings, Sky Walk, Wall Branding, Gantry Gate",
    name: "Wall Branding",
  },
  {
    key: 6,
    value: "Offline Media Output File - Others",
    name: "Activation",
  },
  {
    key: 7,
    value: "Offline Media Output File - Others",
    name: "Ambient Media",
  },
  {
    key: 8,
    value: "Offline Media Output File - Others",
    name: "Banners",
  },
  {
    key: 9,
    value: "Offline Media Output File - Others",
    name: "Boarding Pass",
  },
  {
    key: 10,
    value: "Offline Media Output File - Others",
    name: "Bus Handles",
  },
  {
    key: 11,
    value: "Offline Media Output File - Others",
    name: "Bus Shelters",
  },
  {
    key: 12,
    value: "Offline Media Output File - Others",
    name: "Dangler",
  },
  {
    key: 13,
    value: "Offline Media Output File - Others",
    name: "Door Handles",
  },
  {
    key: 14,
    value: "Offline Media Output File - Others",
    name: "Drop Down Banners",
  },
  {
    key: 15,
    value: "Offline Media Output File - Others",
    name: "Elevator Branding",
  },
  {
    key: 16,
    value: "Offline Media Output File - Others",
    name: "Escalator Branding",
  },
  {
    key: 17,
    value: "Offline Media Output File - Others",
    name: "Flight Wrap",
  },
  {
    key: 18,
    value: "Offline Media Output File - Others",
    name: "Kiosk",
  },
  {
    key: 19,
    value: "Offline Media Output File - Others",
    name: "Others",
  },
  {
    key: 20,
    value: "Offline Media Output File - Others",
    name: "Pole Kiosk",
  },
  {
    key: 21,
    value: "Offline Media Output File - Others",
    name: "Poster",
  },
  {
    key: 22,
    value: "Offline Media Output File - Others",
    name: "Posters",
  },
  {
    key: 23,
    value: "Offline Media Output File - Others",
    name: "Promoter Activity",
  },
  {
    key: 24,
    value: "Offline Media Output File - Others",
    name: "Standee",
  },
  {
    key: 25,
    value: "Offline Media Output File - Others",
    name: "Tent Card",
  },
  {
    key: 26,
    value: "Offline Media Output File - Others",
    name: "Ticket Branding",
  },
  {
    key: 27,
    value: "Offline Media Output File - Others",
    name: "Train Wrap",
  },
];

const MediaOfflineBulkUploadPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [upload, setUpload] = useState(null);
  const [data, setData] = useState(false);
  const [prDropdown, setprDropdown] = useState(true);
  const [loading, setLoading] = useState(false);
  const [offlineCategory, setOfflineCategory] = useState("");
  const [storeCompanyType, setStoreCompanyType] = useState("");
  const [storeStoredFiles, setStoreStoredFiles] = useState([]);

  const [activeStepIndex, setactiveStepIndex] = useState(0);
  const [Filedata, setfileData] = useState();
  const [UploadedProductsCounts, setUploadedProductsCounts] = useState();
  const [webhookresstatus, setwebhookresstatus] = useState();
  const [webhookres, setwebhookres] = useState();

  const steps = [
    "Choose an Excel file and upload it to Amazon's Bulk Upload Module.",
    "AI will process the data and email the output within 24 hours.",
    "Check the output file, make the necessary changes, and reupload the updated file.",
    "Receive mail notification, review details, upload images, and go live.",
  ];

  const CustomStepIcon = (props) => {
    const { active, completed, icon } = props;

    let color = "#dadada"; // Default gray color
    let content = icon; // Step Number

    if (completed) {
      return (
        <CheckCircleIcon
          sx={{ fontSize: "27px", color: "#4AA500", mb: -0.5 }}
        />
      );
    }

    if (completed) {
      color = "#4AA500"; // Active step green number
    } else if (Number(icon) === activeStepIndex + 1) {
      color = "#EBB810"; // Next pending step
    }

    return (
      <Box
        sx={{
          width: "23px",
          height: "23px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Kumbh Sans",
          fontSize: "14px",
          backgroundColor:
            content === 3 &&
            activeStepIndex === 2 &&
            (webhookresstatus === 202 || webhookresstatus === 400) &&
            !Filedata?.IsAdminUploaded
              ? "#C60000"
              : `${color}`,
          color: "white",
        }}
      >
        {content}
      </Box>
    );
  };

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const myForm = new FormData();
    myForm.append("file", file);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      setUpload(data);
    };

    reader.onerror = (err) => {};
    reader?.readAsArrayBuffer(file);

    if (
      Filedata?.IsErrorDownload &&
      Filedata?.step_no !== 4 &&
      Filedata?.step_no !== 3
    ) {
      uploadErrorExcelFile(file);
    } else {
      uploadExcelFile(file);
    }
  };

  const findAllWebHookReponsesProducts = async (id) => {
    try {
      await axios
        .post(
          `publiq_bulk_upload/get_products_by_bulk_response_id`,
          {
            data: id,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response?.data?.countWithoutImages === 0 && id) {
            ChangeComapnyStepsandStatus(true, Filedata, id);
          }
          setUploadedProductsCounts(response?.data?.countWithImages);
        })
        .catch((error) => {
          console.error("Error fetching :", error.message);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  const uploadExcelFile = async (myForm) => {
    if (offlineCategory === "" || !offlineCategory) {
      GlobalToast("Please select an Offline category", "error");
      return;
    }
    try {
      setLoading(true);

      const selectedCategory = MediaOffline.find(
        (item) => item.name === offlineCategory
      );

      const formData = new FormData();
      formData.append("file", myForm);
      formData.append("data", selectedCategory?.value);
      formData.append("subcategory", selectedCategory?.name);
      const { data } = await axios.post(
        "publiq_bulk_upload/bulk_upload",
        formData,
        {
          headers: { "Content-type": "multipart/form-data" },
          withCredentials: true,
        }
      );
      if (data?.success === true) {
        CreateComapnySteps(data?.storeResponse);
        toast.success("File uploaded successfully", {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      setData(data?.success);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.name, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        console.error("Network Error:", error.message);
      }
    }
  };

  const uploadErrorExcelFile = async (myForm) => {
    try {
      const formData = new FormData();
      formData.append("file", myForm);
      formData.append("webhook_id", Filedata?.webhook_response_id);
      const { data } = await axios.post(
        "publiq_bulk_upload/bulk_error_file_upload_User",
        formData,
        {
          headers: { "Content-type": "multipart/form-data" },
          withCredentials: true,
        }
      );
      if (data?.file_Uploaded === true) {
        toast.success("File uploaded successfully", {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        console.error("Network Error:", error.message);
      }
    }
  };

  const checklatest = async () => {
    try {
      await axios
        .post(`publiq_bulk_upload/fetch_company_upload`, {
          withCredentials: true,
        })
        .then((response) => {
          findAllWebHookReponsesProducts(
            response?.data?.company_Upload?.webhook_response_id
          );
          if (!response?.data?.company_found) {
            setactiveStepIndex(0);
          } else if (response?.data?.company_found) {
            setactiveStepIndex(
              response?.data?.company_Upload?.step_no === 4
                ? 0
                : response?.data?.company_Upload?.step_no
            );
            setfileData(response?.data?.company_Upload);
            setwebhookresstatus(
              response?.data?.company_Upload?.webhook_response?.status_code || 0
            );
            setwebhookres(response?.data?.company_Upload?.webhook_response);
          }
        })
        .catch((error) => {
          // GlobalToast(error.response.data.message, "error");
        });
    } catch (error) {
      // GlobalToast(error.response.data.message, "error");
    }
  };

  const CreateComapnySteps = async (data) => {
    try {
      await axios
        .post(
          `publiq_bulk_upload/create_company_upload`,
          {
            storeFile: data,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          // GlobalToast(error.response.data.message, "error");
        });
    } catch (error) {
      // GlobalToast(error.response.data.message, "error");
    }
  };

  const ChangeComapnyStepsandStatus = async (IsPreview, filedata, id) => {
    try {
      await axios
        .post(
          `publiq_bulk_upload/change_uploaded_file_status`,
          {
            IsPreview: IsPreview,
            webhook_id: filedata?.webhook_response_id || id,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          checklatest();
        })
        .catch((error) => {
          // GlobalToast(error.response.data.message, "error");
        });
    } catch (error) {
      // GlobalToast(error.response.data.message, "error");
    }
  };

  const UploadAllProducts = async (IsPreview, IsDeleted, filedata) => {
    try {
      await axios
        .post(
          `publiq_bulk_upload/upload_bulkUpload_files_mediaoffline`,
          {
            data: filedata?.webhook_response_id,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response) {
            ChangeComapnyStepsandStatus(IsPreview, filedata);
          }
          navigate("/home/bulkuploadexcelpreview", {
            state: {
              id: filedata?.webhook_response_id,
              isMedia: true,
              isMediaoffline: true,
            },
          });
          localStorage.setItem("isMediaoffline", true);
          localStorage.setItem("isProduct", false);
          localStorage.setItem("isMediaonline", false);
        })
        .catch((error) => {
          GlobalToast(error.response.data.message, "error");
        });
    } catch (error) {}
  };

  const confirmedUploadTheFile = async (isPreview, IsUploaded) => {
    if (Filedata && !Filedata?.IsPreview && !Filedata?.IsProductsUploaded) {
      if (window.confirm("Are you sure you want to add products?")) {
        UploadAllProducts(Filedata?.IsPreview, Filedata?.IsDeleted, Filedata);
        GlobalToast("New File Uploading...", "success");
      }
    } else if (
      Filedata &&
      Filedata?.IsDeleted &&
      Filedata?.IsPreview &&
      !Filedata?.IsProductsUploaded
    ) {
      if (window.confirm("Are you sure you want to add products?")) {
        UploadAllProducts(Filedata?.IsPreview, Filedata?.IsDeleted, Filedata);
        GlobalToast("File Re-Uploading...", "success");
      }
    } else if (
      Filedata &&
      !Filedata?.IsDeleted &&
      Filedata?.IsPreview &&
      !Filedata?.IsProductsUploaded
    ) {
      navigate("/home/bulkuploadexcelpreview", {
        state: {
          id: Filedata?.webhook_response_id,
          productUplodedstatus: Filedata?.IsPreview,
          isPreview: isPreview,
          IsUploaded: IsUploaded,
        },
      });
      GlobalToast("File Already Uploaded", "success");
    } else {
      // navigate("/home/bulkuploadexcelpreview", {
      //   state: {
      //     id: Filedata?.webhook_response_id,
      //     productUplodedstatus: Filedata?.IsPreview,
      //     isPreview: isPreview,
      //     IsUploaded: IsUploaded,
      //   },
      // });
      GlobalToast("File Uploaded", "success");
    }
  };

  const changeErrorfilestatus = async () => {
    try {
      await axios
        .post(
          `publiq_bulk_upload/change_error_file_upload_status`,
          {
            webhook_id: Filedata?.webhook_response_id,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          GlobalToast(error.response.data.message, "error");
        });
    } catch (error) {}
  };

  const handleMediaOfflineCategoryChange = (event) => {
    const name = event.target.value;

    setOfflineCategory(name);
  };

  useEffect(() => {
    const companyType = localStorage.getItem("companyType");
    setStoreCompanyType(companyType);
    checklatest();
  }, []);

  const handleDownload = async () => {
    if (!webhookres?.Link) {
      alert("No link available to download!");
      return;
    }

    try {
      const response = await fetch(webhookres.Link, {
        method: "GET",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const filename = webhookres.Link.split("/").pop() || "output-file.xlsx";

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);

      const userConfirmed = window.confirm(
        "Did the file download successfully?"
      );
      if (userConfirmed) {
        changeErrorfilestatus();
      }
      if (!userConfirmed) {
        alert("Download may have failed. Please try again.");
      }
    } catch (error) {
      alert("Download failed! Please check the file URL or try again.");
    }
  };

  return (
    <>
      <BreadCrumbHeader title="Bulk Upload" MainText={"Bulk Upload"} />

      <Paper
        sx={{
          width: "100%",
          height: "70vh",
          display: "flex",
          flexDirection: "column",
          overflowY: "scroll",
          py: 1,
        }}
        elevation={0}
      >
        <Box sx={{ width: "100%", mt: 1 }}>
          <Stepper
            activeStep={activeStepIndex}
            alternativeLabel
            connector={
              <StepConnector
                sx={{
                  "& .MuiStepConnector-line": {
                    borderColor: "#BDBDBD",
                  },
                }}
              />
            }
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={CustomStepIcon}>
                  <Typography
                    sx={{
                      width: "100%",
                      textAlign: "center",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Box sx={mainstepbox}>
            <Box
              sx={{
                ...stepboxsec,
                border: "2.5px solid #4AA500",
                borderColor:
                  activeStepIndex === 0
                    ? "#EBB810"
                    : activeStepIndex > 0
                    ? "#4AA500"
                    : "#AAAAAA",
              }}
            >
              <Box
                sx={{
                  height: "10%",
                }}
              >
                <Box component={"img"} src={headtag} sx={headimg} />
                <Typography sx={headText}>Upload</Typography>
              </Box>
              <Box component={"img"} src={step1} sx={stepimg} />
              <Box
                sx={{
                  width: "50%",
                  height: "30%",
                  // bgcolor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: "15px",
                }}
              >
                <FormControl fullWidth>
                  <select
                    labelId="category-label"
                    value={offlineCategory}
                    label="Category"
                    defaultValue={""}
                    onChange={handleMediaOfflineCategoryChange}
                    style={{
                      border: "1px solid #c64091",
                      height: "35px",
                      width: "100%",
                      borderRadius: "5px",
                      fontFamily: "Poppins",
                      fontSize: "15px",
                      lineHeight: "1.5",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <option
                      value={""}
                      disabled={true}
                      style={{
                        padding: "10px",
                        height: "35px",
                        width: "100%",
                      }}
                    >
                      <Typography variant="h6">{`<-- Select -->`}</Typography>
                    </option>
                    {MediaOffline?.map((res, idx) => {
                      return (
                        <option
                          key={idx}
                          value={res?.name}
                          style={{
                            padding: "10px",
                            height: "35px",
                            width: "100%",
                          }}
                        >
                          <Typography variant="h6">{res?.name}</Typography>
                        </option>
                      );
                    })}
                  </select>
                </FormControl>
                <input
                  type="file"
                  ref={inputFile}
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                />
                <Button
                  variant="contained"
                  sx={stepbtn}
                  onClick={onButtonClick}
                  disabled={activeStepIndex === 0 ? false : true}
                >
                  <Box component={"img"} src={exportimg} sx={iconimg} /> Upload
                  File
                </Button>
              </Box>
            </Box>
          </Box>
          <Box sx={mainstepbox}>
            <Box
              sx={{
                ...stepboxsec,
                border: "2.5px solid #4AA500",
                borderColor:
                  activeStepIndex === 1
                    ? "#EBB810"
                    : activeStepIndex > 1
                    ? "#4AA500"
                    : "#AAAAAA",
              }}
            >
              <Box
                sx={{
                  height: "10%",
                }}
              >
                <Box
                  component={"img"}
                  src={headtag}
                  sx={{
                    ...headimg,
                    filter:
                      activeStepIndex === 1 || activeStepIndex > 1
                        ? "none"
                        : "grayscale(100%) brightness(250%)",
                  }}
                />
                <Typography sx={headText}>AI Process</Typography>
              </Box>
              <Box component={"img"} src={step1} sx={stepimg} />
              <Box
                sx={{
                  height: "30%",
                }}
              >
                {activeStepIndex === 1 ? (
                  <CircularProgress sx={{ color: "#C83184" }} />
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box sx={mainstepbox}>
            <Box
              sx={{
                ...stepboxsec,
                border: "2.5px solid #4AA500",
                borderColor:
                  activeStepIndex === 2 && webhookresstatus === 200
                    ? "#EBB810"
                    : webhookresstatus === 400 && activeStepIndex >= 2
                    ? "#C60000"
                    : webhookresstatus === 202 &&
                      activeStepIndex > 2 &&
                      Filedata?.IsAdminUploaded
                    ? "#4AA500"
                    : webhookresstatus === 202 &&
                      activeStepIndex === 2 &&
                      Filedata?.IsAdminUploaded
                    ? "#EBB810"
                    : webhookresstatus === 202 && activeStepIndex >= 2
                    ? "#C60000"
                    : webhookresstatus === 200 && activeStepIndex > 2
                    ? "#4AA500"
                    : "#AAAAAA",
              }}
            >
              <Box
                sx={{
                  height: "10%",
                }}
              >
                <Box
                  component={"img"}
                  src={headtag}
                  sx={{
                    ...headimg,
                    filter:
                      activeStepIndex === 2 || activeStepIndex > 2
                        ? "none"
                        : "grayscale(100%) brightness(250%)",
                  }}
                />
                <Typography sx={headText}>Download</Typography>
              </Box>
              <Box component={"img"} src={step1} sx={stepimg} />
              <Box
                sx={{
                  width: "50%",
                  height: "30%",
                  // bgcolor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                {(webhookresstatus === 202 || webhookresstatus === 400) &&
                !webhookres?.Link &&
                activeStepIndex >= 2 ? (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        color: "#5D5D5DCC",
                        width: "100%",
                        whiteSpace: "nowrap",
                        // lineHeight: "30px",
                      }}
                    >
                      AI is Faild to Process <br />
                      Please Click here to re-upload
                    </Typography>
                  </Box>
                ) : webhookresstatus === 202 &&
                  Filedata?.IsErrorDownload &&
                  Filedata?.step_no !== 4 &&
                  Filedata?.step_no !== 3 &&
                  !Filedata?.IsAdminUploaded &&
                  activeStepIndex >= 2 ? (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        color: "#5D5D5DCC",
                        width: "100%",
                        whiteSpace: "nowrap",
                        // lineHeight: "30px",
                      }}
                    >
                      Bulk Upload Processed with <br /> Missing Data Please
                      Click here <br />
                      to upload for Admin
                    </Typography>
                  </Box>
                ) : webhookresstatus === 202 &&
                  !Filedata?.IsAdminUploaded &&
                  activeStepIndex >= 2 ? (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        color: "#5D5D5DCC",
                        width: "100%",
                        whiteSpace: "nowrap",
                        // lineHeight: "30px",
                      }}
                    >
                      Bulk Upload Processed with <br /> Missing Data Please
                      Click here <br />
                      to dowload and re-upload
                    </Typography>
                  </Box>
                ) : null}
                <input
                  type="file"
                  ref={inputFile}
                  onChange={handleFileUpload}
                  style={{ display: "none" }}
                />
                {(webhookresstatus === 202 || webhookresstatus === 400) &&
                Filedata?.IsErrorDownload &&
                Filedata?.step_no !== 4 &&
                Filedata?.step_no !== 3 &&
                !Filedata?.IsAdminUploaded &&
                activeStepIndex >= 2 ? (
                  <Button
                    onClick={onButtonClick}
                    variant="contained"
                    sx={stepbtn}
                    disabled={
                      activeStepIndex === 2 || activeStepIndex > 2
                        ? false
                        : true
                    }
                  >
                    <Box component={"img"} src={importimg} sx={iconimg} />{" "}
                    Upload For Admin
                  </Button>
                ) : (webhookresstatus === 202 || webhookresstatus === 400) &&
                  !webhookres?.Link &&
                  !Filedata?.IsAdminUploaded &&
                  activeStepIndex >= 2 ? (
                  <Button
                    variant="contained"
                    sx={stepbtn}
                    disabled={
                      activeStepIndex === 2 || activeStepIndex > 2
                        ? false
                        : true
                    }
                    onClick={() => {
                      changeErrorfilestatus();
                    }}
                  >
                    <Box component={"img"} src={exportimg} sx={iconimg} />{" "}
                    Upload File
                  </Button>
                ) : (webhookresstatus === 202 || webhookresstatus === 400) &&
                  !Filedata?.IsAdminUploaded &&
                  activeStepIndex >= 2 ? (
                  <Button
                    onClick={handleDownload}
                    variant="contained"
                    sx={stepbtn}
                    disabled={
                      activeStepIndex === 2 || activeStepIndex > 2
                        ? false
                        : true
                    }
                  >
                    <Box component={"img"} src={importimg} sx={iconimg} />{" "}
                    Output File
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      sx={{
                        ...stepbtn,
                        backgroundColor: "transparent",
                        border: "1px solid #000",
                        color: "#000",
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                        "&:disabled": {
                          border: "1px solid transparent",
                        },
                      }}
                      disabled={
                        activeStepIndex === 2 || activeStepIndex > 2
                          ? false
                          : true
                      }
                      onClick={() => {
                        if (activeStepIndex === 2 || activeStepIndex > 2) {
                          confirmedUploadTheFile(true, false);
                        } else {
                          return;
                        }
                      }}
                    >
                      <VisibilityOutlinedIcon
                        sx={{ fontSize: "20px", p: 0.8 }}
                      />{" "}
                      Preview
                    </Button>
                    <Button
                      target="_blank"
                      href={
                        Filedata?.IsAdminUploaded
                          ? Filedata?.Admin_uploaded_file
                          : webhookres?.Link
                      }
                      variant="contained"
                      sx={stepbtn}
                      disabled={
                        activeStepIndex === 2 || activeStepIndex > 2
                          ? false
                          : true
                      }
                    >
                      <Box component={"img"} src={importimg} sx={iconimg} />{" "}
                      Download
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Box>
          <Box sx={mainstepbox}>
            <Box
              sx={{
                ...stepboxsec,
                border: "2.5px solid #4AA500",
                borderColor:
                  activeStepIndex === 3
                    ? "#EBB810"
                    : activeStepIndex > 3
                    ? "#4AA500"
                    : "#AAAAAA",
              }}
            >
              <Box
                sx={{
                  height: "10%",
                }}
              >
                <Box
                  component={"img"}
                  src={headtag}
                  sx={{
                    ...headimg,
                    filter:
                      activeStepIndex === 3 || activeStepIndex > 3
                        ? "none"
                        : "grayscale(100%) brightness(250%)",
                  }}
                />
                <Typography sx={headText}>Go Live</Typography>
              </Box>
              <Box component={"img"} src={step1} sx={stepimg} />
              <Box
                sx={{
                  width: "50%",
                  height: "30%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {activeStepIndex === 3 || activeStepIndex > 3 ? (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: "18px",
                        textAlign: "center",
                      }}
                    >
                      {UploadedProductsCounts || 0} Products
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "14px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        color: "#5D5D5DCC",
                        lineHeight: "30px",
                      }}
                    >
                      Send for Admin Approval.
                    </Typography>
                  </Box>
                ) : null}
                <Button
                  disabled={
                    activeStepIndex === 3 || activeStepIndex > 3 ? false : true
                  }
                  variant="contained"
                  sx={stepbtn}
                  onClick={() => {
                    if (activeStepIndex === 3 || activeStepIndex > 3) {
                      confirmedUploadTheFile(false, true);
                    } else {
                      return;
                    }
                  }}
                >
                  <Box component={"img"} src={uploadimg} sx={iconimg} /> Upload
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default MediaOfflineBulkUploadPage;

const mainstepbox = {
  width: "24%",
  height: "auto",
  // bgcolor: "red",
  display: "flex",
  justifyContent: "center",
  mt: 2,
  // position: "relative",
};

const stepboxsec = {
  width: "280px",
  height: "440px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "10px",
  position: "relative",
};

const stepimg = {
  width: "80%",
  height: "auto",
  borderRadius: "8px",
};

const iconimg = {
  width: "20px",
  height: "auto",
  padding: 1,
};

const headimg = {
  width: "90%",
  height: "auto",
  borderRadius: "8px",
  position: "absolute",
  top: 20,
  left: -25,
};

const headText = {
  position: "absolute",
  zIndex: 1,
  left: 0,
  top: 23,
  fontFamily: "Poppins",
  fontWeight: 500,
  color: "white",
  fontSize: "22px",
  textAlign: "center",
  width: "80%",
};

const stepbtn = {
  width: "100%",
  height: "45px",
  borderRadius: "8px",
  backgroundColor: "#C83184",
  boxShadow: "none",
  textTransform: "none",
  fontSize: "13px",
  fontWeight: 300,
  "&:hover": {
    backgroundColor: "#C83184",
  },
};
